<div class="profile-picture" [style.height]="size + 'px'" [style.width]="size + 'px'">

	<mat-icon *ngIf="!src && !type" svgIcon="person_svg" inline="true" class="placeholder-icon"></mat-icon>
	<mat-icon *ngIf="!src && type === 1" svgIcon="placeholder_sl" inline="true" class="placeholder-icon"></mat-icon>
	<mat-icon *ngIf="!src && type === 2" svgIcon="placeholder_pg" inline="true" class="placeholder-icon"></mat-icon>

	<img *ngIf="src" [src]="src" alt="Profile image">

</div>